import snakeCaseKeys from 'snakecase-keys';

export default (value, options = {}) => snakeCaseKeys(value, options);
